import React from 'react'
import { MetaTags } from 'react-meta-tags'
import { META_DESCRIPTION } from '../../../../utils/constants'
import {Button, Card, Col, Layout, Result, Row, Space, Typography} from 'antd'
import {ReloadOutlined, ExclamationCircleOutlined} from '@ant-design/icons'
import ROUTES from '../../../../utils/routes'
import { useState } from 'react'
import { ApiBaseHelper } from '../../../../utils/api-base-helper'
import { useDispatch, useSelector } from 'react-redux'
import { updateTech } from '../../../../redux/reducers/app'
import { useHistory } from 'react-router-dom'

const {Content} = Layout
const {Text} = Typography

const StripeReauth = () => {
    const tech = useSelector(state => state.tech)
    const dispatch = useDispatch()
    const history = useHistory()
    const [isGeneratingLink, setIsGeneratingLink] = useState(false)
    const [linkGenerated, setLinkGenerated] = useState(false)
    const [error, setError] = useState(null)


    if(!tech){
        history.push(ROUTES.DASHBOARD)
    }

    const generateNewAccountLink = async () => {
        setIsGeneratingLink(true)
        setError(null)
        try {
            
            let stripeConnect = await ApiBaseHelper.get({
                url: "stripe/connect-url/" + tech?.Stripe_Connect_Id,
                headers: {
                    Authorization: 'Bearer ' + tech?.token
                }
            });

            let techProfile = {
                ...tech,
                'Stripe_Connect_URL':  stripeConnect.data.data.url,
            };
            dispatch(updateTech(techProfile))
            if (stripeConnect.data.data.url) {
                // Redirect to the new account link
                window.location.href = stripeConnect.data.data.url
            } else {
                throw new Error('Failed to generate account link')
            }
        } catch (error) {
            console.error('Error generating new account link:', error)
            setError('Unable to generate a new connection link. Please try again or contact support.')
            setIsGeneratingLink(false)
        }
    }

    return (
        <>
            <MetaTags>
                <title>Stripe Account Link Expired | TecMe</title>
                <meta name="description" content={META_DESCRIPTION}/>
                <meta name="robots" content="noindex, nofollow"/>
            </MetaTags>
            <Content className="main">
                <div className="page">
                    <div>
                        <div className='auth-container'>
                            <div className='auth-page-ctn'>
                                <Row justify="center" style={{ flexDirection: 'column', alignItems: 'center', minHeight: '85vh', width: '100%' }}>
                                    <Col xs={24} sm={20} md={16} lg={12} xl={10}>
                                        <Card>
                                            {error ? (
                                                <Result
                                                    status="error"
                                                    title="Unable to Continue Setup"
                                                    subTitle={error}
                                                    extra={[
                                                        <Space direction="vertical" size="middle" key="error-actions" style={{ width: '100%' }}>
                                                            <Button
                                                                type="primary"
                                                                size="large"
                                                                onClick={generateNewAccountLink}
                                                                icon={<ReloadOutlined />}
                                                            >
                                                                Try Again
                                                            </Button>
                                                            <Button
                                                                size="large"
                                                                href={ROUTES.DASHBOARD}
                                                            >
                                                                Return to Dashboard
                                                            </Button>
                                                        </Space>
                                                    ]}
                                                />
                                            ) : (
                                                <Result
                                                    icon={<ExclamationCircleOutlined style={{ fontSize: '72px', color: '#faad14' }} />}
                                                    title="Stripe Setup Link Expired"
                                                    subTitle="The Stripe setup link you used has expired or is no longer valid."
                                                    extra={[
                                                        <Space direction="vertical" size="large" key="actions" style={{ width: '100%' }}>
                                                            <div style={{ textAlign: 'center' }}>
                                                                <Text style={{color: 'rgba(0, 0, 0, 0.65)'}}>
                                                                    This can happen if the link was previously visited, has been open too long, or has expired. 
                                                                    We'll generate a new link to continue your Stripe account setup.
                                                                </Text>
                                                            </div>
                                                            <Button
                                                                type="primary"
                                                                size="large"
                                                                loading={isGeneratingLink}
                                                                onClick={generateNewAccountLink}
                                                                icon={<ReloadOutlined />}
                                                            >
                                                                {isGeneratingLink ? 'Generating New Link...' : 'Continue Setup'}
                                                            </Button>
                                                            <div style={{ textAlign: 'center' }}>
                                                                <Text style={{color: 'rgba(0, 0, 0, 0.45)'}}>
                                                                    You'll be redirected to Stripe to continue where you left off
                                                                </Text>
                                                            </div>
                                                        </Space>
                                                    ]}
                                                />
                                            )}
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div> 
            </Content>
        </>
    )
}

export default StripeReauth